import * as THREE from 'three';
import { CameraTransition } from './camera-transition';

export interface CameraViewPose {
  position: THREE.Vector3;
  up: THREE.Vector3;
}

/** Coordinates animated camera transitions and standard view-cube orientations. */
export class CameraController {
  private readonly transition = new CameraTransition();

  public start(
    camera: THREE.Camera,
    targetPosition: THREE.Vector3,
    targetUp: THREE.Vector3,
    targetLook: THREE.Vector3,
    duration = 320,
    startTarget = new THREE.Vector3(),
  ): void {
    this.transition.start(camera, targetPosition, targetUp, targetLook, duration, startTarget);
  }

  public cancel(): void { this.transition.cancel(); }

  public update(
    camera: THREE.Camera,
    controls: { object: THREE.Camera; target: THREE.Vector3; update(): void },
    setOrthoFrustum: (halfHeight: number) => void,
    orthoHalfHeightForDistance: (distance: number) => number,
  ): void {
    this.transition.update(camera, controls, setOrthoFrustum, orthoHalfHeightForDistance);
  }

  public poseForViewCube(
    cameraPosition: THREE.Vector3,
    target: THREE.Vector3,
    viewDirection: THREE.Vector3,
  ): CameraViewPose {
    const direction = viewDirection.clone().normalize();
    const distance = cameraPosition.distanceTo(target);
    const up = Math.abs(direction.z) > 0.95
      ? new THREE.Vector3(0, direction.z > 0 ? 1 : -1, 0)
      : new THREE.Vector3(0, 0, 1);
    return {
      position: target.clone().addScaledVector(direction, distance),
      up,
    };
  }
}
